<template>
  <div>
    <v-form @submit.prevent="clickConfirm()" ref="confirm" v-if="!isDialogPrintContrcts && !isLoadingRenew">
      <v-card-text class="overflow-y-auto dialog-renew-form-in">
        <div class="confirm-renew-box">
          <div class="col-1" v-if="!isFormApprove">
            {{ $t('contract.renew_all_contract') }} <b>{{ contracts.length }}</b> {{ $t('contract.title') }}
          </div>
          <div class="col-2">
            <span>{{ $t('contract.start_date') }}</span>
            <v-menu ref="dialogStartDate" v-model="dialogStartDate" :close-on-content-click="false"
              :return-value.sync="form.startDate_tmp" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field solo flat background-color="grey lighten-4"
                  :value="$helper.datelabel(form.startDate_tmp)" :label="$t('contract.start_date')"
                  prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" 
                  :disabled="isMainDisabled"></v-text-field>
              </template>
              <v-date-picker v-model="form.startDate_tmp" no-title scrollable locale="th"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint
                :min="$moment().format(dateTimeFormat)">
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="dialogStartDate = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="success"
                  @click="$refs.dialogStartDate.save(form.startDate_tmp); changeStartDate()">{{ $t('confirm') }}</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="col-2">
            <span>{{ $t('contract.end_date') }}</span>
            <v-menu ref="dialogEndDate" v-model="dialogEndDate" :close-on-content-click="false"
              :return-value.sync="form.endDate_tmp" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field solo flat background-color="grey lighten-4"
                  :value="$helper.datelabel(form.endDate_tmp)" :label="$t('contract.end_date')"
                  prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  :disabled="isMainDisabled"></v-text-field>
              </template>
              <v-date-picker v-model="form.endDate_tmp" no-title scrollable locale="th" persistent-hint
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                :min="form.startDate_tmp">
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="dialogEndDate = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="success" @click="$refs.dialogEndDate.save(form.endDate_tmp)">{{ $t('confirm') }}</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="col-1">
            <div class="space-between">
              <h3>{{ $t('customer.document_set_list') }}</h3>
              <v-btn color="info" small elevation="0" @click="contractDocumentDialog($event, false)"
                :disabled="isRenewLoading || isLoading || isMainDisabled" :loading="isRenewLoading || isLoading">
                <v-icon left>mdi-plus-box</v-icon>{{ $t('contract.add_contract_document') }}
              </v-btn>
            </div>
            <div class="py-5">
              <CardContractDocument v-for="(item, index) in form.documents_tmp" :key="`doc_${index}`"
                :indexNumber="`${index + 1}`" :object="item" @onView="contractDocumentDialog(item, true)"
                @onRemove="contractDocumentRemoveDialog(index)" :isUpdate="false"
                :isDisabled="isMainDisabled" />
              <CardContractDocument v-if="form.documents_tmp.length == 0" :isNull="true" />
            </div>
          </div>
          <div class="col-1">
            <h3><span v-if="!form.effectiveType" class="red-note-head">*</span>{{ $t('contract.effective_date_of_renew_stall_contract') }}</h3>
            <v-radio-group v-model="form.effectiveType" hide-details required :disabled="isMainDisabled">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="checkRenewApprove ? on : null" class="mb-2">
                    <v-radio :label="$t('customer.effective_immediately_after_confirm')" value="now" :disabled="checkRenewApprove"></v-radio>
                  </div>
                </template>
                <div>{{ $t('task.if_approve_contract_will_not_effective_immediately') }}</div>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="checkDisabledRatio() ? on : null" class="mb-2">
                    <v-radio :label="$t('contract.effective_according_to_contract_start_date')" value="startDate" :disabled="checkDisabledRatio()"></v-radio>
                  </div>
                </template>
                <div v-if="checkRenewApprove">{{ $t('task.if_approve_contract_will_not_effective_immediately') }}</div>
                <div v-else>{{ $t('contract.effective_according_to_contract_start_date_today') }}</div>
              </v-tooltip>
              <v-radio :label="$t('contract.effective_date_selected')" value="effectiveDate"></v-radio>
            </v-radio-group>
          </div>
          <div v-if="form.effectiveType == 'startDate'" class="col-2 pl-10">
            <v-text-field solo flat background-color="grey lighten-4" :value="$helper.datelabel(form.startDate_tmp)"
              :label="$t('contract.start_date')" disabled prepend-inner-icon="mdi-calendar" readonly></v-text-field>
          </div>
          <div v-else-if="form.effectiveType == 'effectiveDate'" class="col-2 pl-10">
            <v-menu ref="dialogEffectiveDate" v-model="dialogEffectiveDate" :close-on-content-click="false"
              :return-value.sync="form.effectiveDate_tmp" transition="scale-transition" offset-y min-width="auto"
              :disabled="form.effectiveType == 'startDate'">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field solo flat background-color="grey lighten-4"
                  :disabled="form.effectiveType == 'startDate' || isMainDisabled" :value="$helper.datelabel(form.effectiveDate_tmp)"
                  :label="$t('contract.effective_date_of_renew_contract')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.effectiveDate_tmp" no-title scrollable locale="th"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint
                :min="$moment().add(1, 'days').format(dateTimeFormat)">
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="dialogEffectiveDate = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="success"
                  @click="$refs.dialogEffectiveDate.save(form.effectiveDate_tmp)">{{ $t('confirm') }}</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-card-text>
      <v-divider v-if="!isFormApprove"></v-divider>
      <v-card-actions v-if="!isFormApprove">
        <div v-if="!form.documents_tmp || form.documents_tmp.length == 0" class="warning-note">
          {{ $t('validate.please_add_contract_document_if_have') }}</div>
        <div v-if="!form.effectiveType" class="red-note">*{{ $t('validate.please_select_effective_date_of_renew_stall_contract') }}</div>
        <v-spacer></v-spacer>
        <v-btn color="black" elevation="1" outlined large @click="dismiss()"
          :disabled="isRenewLoading || isLoading" :loading="isRenewLoading || isLoading">{{ $t('close') }}</v-btn>
        <v-btn color="success" elevation="1"
          :disabled="isRenewLoading || isLoading || !form.effectiveType ? true : false"
          :loading="isRenewLoading || isLoading" large type="submit">{{ $t('confirm') }}</v-btn>
      </v-card-actions>
    </v-form>
    <div v-if="isLoadingRenew" class="py-8 d-flex justify-center align-center" elevation="0">
      <v-overlay absolute opacity="1" color="white">
        <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
      </v-overlay>
    </div>
    <ContractsDocument v-model="isContractDocument" :projectId="projectId" :marketId="marketId"
      :object-id="isContractDocumentId" :isDisable="isContractDocumentDisable" :document="contractDocument"
      @onSave="contractDocumentSave" />
    <LoadingPercentDialog v-model="isRenewLoading" :final="loadingFinal" :initial="loadingInitial" />
    <v-dialog v-model="isConfirmDialog" persistent max-width="400px" >
      <v-card>
        <v-card-title>{{ $t('contract.confirm_renew_contract_only') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <div v-if="countRenew" class="pb-1">{{ $t('contract.renew_all_contract_only') }} <b>{{ countRenew }}</b> {{ $t('contract.title') }}</div>
          <div v-if="countAppove">{{ $t('task.approve_all_contract') }} <b>{{ countAppove }}</b> {{ $t('contract.title') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            elevation="1" 
            @click="isConfirmDialog = false"
            :disabled="isRenewLoading"
          >
            {{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="1" 
            @click="saveRenewContract()"
            :disabled="isRenewLoading"
          >
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ContractsDocument from "@/components/ContractsDocument.vue";
import CardContractDocument from "@/components/CardContractDocument.vue";
import DocumentEditorDialog from "@/components/DocumentEditorDialog.component.vue"
import ContractDetailDialog from "@/components/ContractDetailDialog";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component";
import { BillingSetting, AreaAccountingProduct, ContractTemplate } from "../classes"
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  components: {
    ContractsDocument,
    CardContractDocument,
    DocumentEditorDialog,
    ContractDetailDialog,
    LoadingPercentDialog
  },
  data() {
    return {
      project: null,
      market: null,
      isLoading: false,
      isRenewLoading: false,
      loadingFinal: 0,
      loadingInitial: 0,
      dialogStartDate: false,
      dialogEndDate: false,
      dialogEffectiveDate: false,
      isDialogPrintContrcts: false,
      hashTemplate: null,
      isDocumentEditorDialog: false,
      tempContractTemplate: null,
      isPrinted: false,
      form: {
        marketId: this.marketId,
        startDate_tmp: this.$moment().format(this.dateTimeFormat),
        startDate: "",
        endDate_tmp: this.$moment()
          .add(1, "months")
          .format(this.dateTimeFormat),
        endDate: "",
        contractIds: [],
        contractId: "",
        documents: [],
        documents_tmp: [],
        effectiveType: 'now',
        effectiveDate_tmp: this.$moment().add(1, 'days').format(this.dateTimeFormat),
        effectiveDate: ""
      },
      dateTimeFormat: "YYYY-MM-DD",
      isContractDocument: false,
      isContractDocumentId: "",
      contractDocument: undefined,
      isContractDocumentDisable: false,
      tempContract: null,
      isConfirmDialog: false,
      countAppove: 0,
      countRenew: 0,
      isLoadingRenew: false,
      checkRenewApprove: false
    };
  },
  props: {
    contracts: Array,
    projectId: String,
    marketId: String,
    isMainDisabled: Boolean,
    isFormApprove: Boolean,
  },
  computed: {
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    this.initData()
  },
  methods: {
    ...mapActions({
      getContract: "contract/getContract",
      renewContract: "contract/renewContract",
      createContractDocument: "contractDocument/createContractDocument",
    }),
    async initData(){
      this.chearData()
      for(let contract of this.contracts){
        if(contract.checkRenewApprove){
          this.checkRenewApprove = true
          this.form.effectiveType = 'effectiveDate'
        }
      }
    },
    changeStartDate() {
      if(this.checkDisabledRatio() && !this.checkRenewApprove){
        this.form.effectiveType = 'now'
      }else{
        this.form.effectiveType = 'effectiveDate'
      }
    },
    contractDocumentDialog(e, isDisable = false) {
      if (isDisable) {
        this.contractDocument = e;
      } else {
        this.contractDocument = null;
      }
      this.isContractDocumentDisable = isDisable || false;
      this.isContractDocument = true;
    },
    contractDocumentRemoveDialog(index) {
      this.form.documents_tmp.splice(index, 1);
    },
    contractDocumentSave(data) {
      this.form.documents_tmp.push(data);
      this.isContractDocumentId = data.objectId;
    },
    checkDisabledRatio() {
      let res = false
      if (this.form.startDate_tmp) res = this.$moment(this.form.startDate_tmp, this.dateTimeFormat).endOf('day').isSameOrBefore(this.$moment().endOf('day'))
      return res
    },
    clickConfirm(){
      this.countAppove = 0
      this.countRenew = 0
      for(let contract of this.contracts){
        if(contract.checkRenewApprove){
          this.countAppove += 1
        }else{
          this.countRenew += 1
        }
      }
      this.isConfirmDialog = true;
    },
    async saveRenewContract() {
      if (this.contracts && this.contracts.length) {
        let postData = {
          startDate: this.$moment(this.form.startDate_tmp, this.dateTimeFormat).startOf('day').toDate(),
          endDate: this.$moment(this.form.endDate_tmp, this.dateTimeFormat).endOf('day').toDate(),
          documents: this.form.documents_tmp,
          effectiveType: this.form.effectiveType
        }

        if (this.form.effectiveType == 'effectiveDate') {
          postData.effectiveDate = this.$moment(this.form.effectiveDate_tmp, this.dateTimeFormat).endOf('day').toDate();
        } else if (this.form.effectiveType == 'startDate') {
          postData.effectiveDate = this.$moment(this.form.startDate_tmp, this.dateTimeFormat).startOf('day').toDate();
        }
        
        this.loadingFinal = 0;
        this.hashTemplate = {}
        try {
          this.isRenewLoading = true;
          this.loadingInitial = this.form.contractIds.length;          
          for (let contract of this.contracts) {
            postData.contractId = contract.objectId
            let { contractDocuments } = await this.renewContract(postData);
            for (let document of contractDocuments) {
              if (document.templates) {
                for (let template of document.templates) {
                  if (!this.hashTemplate[template.title]) {
                    this.hashTemplate[template.title] = {
                      title: template.title,
                      paperSetting: template.paperSetting,
                      layout: []
                    }
                  }
                  this.hashTemplate[template.title].layout = [
                    ...this.hashTemplate[template.title].layout,
                    ...template.layout
                  ]
                }
              }
              this.loadingFinal++;
            }
          }
          this.isRenewLoading = false;
        } catch (error) {
          this.isRenewLoading = false;
          this.$toast.show({
            content: this.$t('validate.error_occurred_while_saving_contract_data'),
            color: "error"
          });
        }
        this.chearData();
        this.dismiss()
        this.$emit("onSuccess", {
          hashTemplate: this.hashTemplate
        });
      }
    },
    chearData() {
      this.isAll = false;
      this.form = {
        marketId: this.marketId,
        startDate_tmp: this.$moment().format(this.dateTimeFormat),
        startDate: "",
        endDate_tmp: this.$moment()
          .add(1, "months")
          .format(this.dateTimeFormat),
        endDate: "",
        contractIds: [],
        contractId: "",
        documents: [],
        documents_tmp: [],
        effectiveType: 'now',
        effectiveDate_tmp: this.$moment().add(1, 'days').format(this.dateTimeFormat),
        effectiveDate: "",
      };
    },
    dismiss() {
      this.$emit("onDismiss", true);
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-renew-form-in.v-card__text::v-deep {
  height: 550px;
  max-height: calc(90vh - 65px - 64px);
}
.confirm-renew-box {
  display: flex;
  flex-wrap: wrap;


  .col-1 {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }


  .col-2 {
    width: 50%;
    max-width: 50%;
    min-width: 250px;
    flex-basis: 50%;
  }


  .space-between {
    display: flex;
    justify-content: space-between;
  }
}
.warning-note {
  color: var(--v-warning-base);
  font-size: 18px;
  padding-left: 15px;
}

.red-note-head {
  color: var(--v-error-base);
  font-size: 20px;
  align-items: baseline;
  vertical-align: bottom;
}

.red-note {
  color: var(--v-error-base);
  font-size: 14px;
  padding-left: 15px;
}
</style>
